/* ============================================================
   DELVABLUE — Interactions du thème (vanilla JS, sans dépendance)
   ------------------------------------------------------------
   OÙ COLLER : crée `assets/db-theme.js`, colle ce contenu.
   CHARGEMENT : ajoute dans theme.liquid, juste avant </body> :
       {{ 'db-theme.js' | asset_url | script_tag }}
   Gère : carrousel hero, onglets catégories, galerie produit,
   sélecteurs de variantes, quantité, accordéon, filtres collection,
   tri, produits recommandés, scroll-reveal, ombre header.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Scroll-reveal ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.db-reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Ombre header au scroll ---------- */
  function initHeader() {
    var hdr = document.querySelector('[data-db-header]');
    if (!hdr) return;
    var on = function () {
      hdr.style.boxShadow = window.scrollY > 10 ? '0 6px 24px -16px rgba(34,48,79,.4)' : 'none';
    };
    on();
    window.addEventListener('scroll', on, { passive: true });
  }

  /* ---------- Carrousel hero ---------- */
  function initCarousel(root) {
    (root || document).querySelectorAll('[data-db-carousel]').forEach(function (car) {
      var slides = car.querySelectorAll('.db-slide');
      if (slides.length < 2) return;
      var dotsWrap = car.querySelector('[data-db-dots]');
      var i = 0, timer;

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, idx) {
          var d = document.createElement('button');
          d.className = 'db-dot' + (idx === 0 ? ' active' : '');
          d.type = 'button';
          d.setAttribute('aria-label', 'Slide ' + (idx + 1));
          d.addEventListener('click', function () { go(idx); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }
      function go(n) {
        slides[i].classList.remove('active');
        if (dots[i]) dots[i].classList.remove('active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('active');
        if (dots[i]) dots[i].classList.add('active');
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      var pn = car.querySelector('[data-db-prev]');
      var nx = car.querySelector('[data-db-next]');
      if (pn) pn.addEventListener('click', function () { prev(); restart(); });
      if (nx) nx.addEventListener('click', function () { next(); restart(); });
      function restart() { clearInterval(timer); timer = setInterval(next, 4000); }
      restart();
      car.addEventListener('mouseenter', function () { clearInterval(timer); });
      car.addEventListener('mouseleave', restart);
    });
  }

  /* ---------- Onglets catégories ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-db-tabs]').forEach(function (tabsWrap) {
      var section = tabsWrap.closest('section') || document;
      var cats = section.querySelectorAll('[data-db-cats] [data-c]');
      tabsWrap.querySelectorAll('.db-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabsWrap.querySelectorAll('.db-tab').forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');
          var f = tab.getAttribute('data-filter');
          cats.forEach(function (c) {
            c.style.display = (f === 'all' || c.getAttribute('data-c') === f) ? '' : 'none';
          });
        });
      });
    });
  }

  /* ---------- Accordéon ---------- */
  function initAccordion(root) {
    (root || document).querySelectorAll('[data-db-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.db-acc-item');
        var body = btn.nextElementSibling;
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '';
      });
    });
    // ouvre les éléments déjà marqués .open
    (root || document).querySelectorAll('.db-acc-item.open .db-acc-body').forEach(function (b) {
      b.style.maxHeight = b.scrollHeight + 'px';
    });
  }

  /* ---------- Page produit ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-db-product]').forEach(function (pdp) {
      // galerie
      var mainImg = pdp.querySelector('#db-main-img');
      pdp.querySelectorAll('.db-thumb').forEach(function (th) {
        th.addEventListener('click', function () {
          pdp.querySelectorAll('.db-thumb').forEach(function (t) { t.classList.remove('active'); });
          th.classList.add('active');
          if (mainImg && th.dataset.src) mainImg.src = th.dataset.src;
        });
      });

      // quantité
      var qInput = pdp.querySelector('#db-qty');
      pdp.querySelectorAll('[data-db-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-db-qty'), 10);
          qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) + step);
        });
      });

      // variantes
      var select = pdp.querySelector('#db-variant-select');
      var form = pdp.querySelector('#db-product-form');
      if (!select || !form) return;

      function selectedKey() {
        var radios = form.querySelectorAll('input[type="radio"][name^="options"]:checked');
        return Array.prototype.map.call(radios, function (r) { return r.value; }).join(' / ');
      }
      function updateActiveStates() {
        pdp.querySelectorAll('[data-db-swatch],[data-db-size]').forEach(function (lbl) {
          var input = lbl.querySelector('input');
          lbl.classList.toggle('active', !!(input && input.checked));
          var nameTarget = pdp.querySelector('[data-db-optname="' + lbl.getAttribute('data-opt') + '"]');
          if (nameTarget && input && input.checked && lbl.dataset.n) nameTarget.textContent = lbl.dataset.n;
        });
      }
      function matchVariant() {
        var key = selectedKey();
        var found = null;
        Array.prototype.forEach.call(select.options, function (o) {
          if (o.textContent.trim() === key) found = o;
        });
        if (!found && select.options.length === 1) found = select.options[0];
        if (!found) return;
        select.value = found.value;

        var priceEl = pdp.querySelector('[data-db-price]');
        var compareEl = pdp.querySelector('[data-db-compare]');
        var stickyPrice = pdp.querySelector('[data-db-sticky-price]');
        if (priceEl && found.dataset.price) priceEl.textContent = found.dataset.price;
        if (stickyPrice && found.dataset.price) stickyPrice.textContent = found.dataset.price;
        if (compareEl) compareEl.textContent = found.dataset.compare || '';

        var available = found.dataset.available === 'true';
        var atc = pdp.querySelector('[data-db-atc]');
        var atcText = pdp.querySelector('[data-db-atc-text]');
        if (atc) atc.disabled = !available;
        if (atcText) atcText.textContent = available ? 'Ajouter au panier' : 'Rupture de stock';
      }

      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"][name^="options"]')) {
          updateActiveStates();
          matchVariant();
        }
      });
      updateActiveStates();
    });
  }

  /* ---------- Produits recommandés (chargement async) ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-db-recommendations][data-url]').forEach(function (sec) {
      fetch(sec.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-db-recommendations] .db-prod-grid');
          var target = sec.querySelector('.db-prod-grid');
          if (fresh && target) {
            target.innerHTML = fresh.innerHTML;
            initReveal(sec);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Page collection : filtres + tri ---------- */
  function initCollection(root) {
    (root || document).querySelectorAll('[data-db-col]').forEach(function (form) {
      function submit() {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], [data-db-sort], .db-f-colors input')) submit();
      });
      // prix : soumettre au blur/Enter
      form.querySelectorAll('.db-f-price input').forEach(function (inp) {
        inp.addEventListener('change', submit);
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
      });

      // tiroir filtres mobile
      var panel = form.querySelector('[data-db-filters]');
      var openBtn = form.querySelector('[data-db-filters-toggle]');
      var closeBtn = form.querySelector('[data-db-filters-close]');
      if (openBtn && panel) openBtn.addEventListener('click', function () { panel.classList.add('open'); });
      if (closeBtn && panel) closeBtn.addEventListener('click', function () { panel.classList.remove('open'); });
    });
  }

  /* ---------- Init global ---------- */
  function init(root) {
    initReveal(root);
    initCarousel(root);
    initTabs(root);
    initAccordion(root);
    initProduct(root);
    initCollection(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    init(document);
    initRecommendations();
  });

  // re-init lors de l'édition dans le personnalisateur Shopify
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
